import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { CreditosService } from './creditos.service';
import { CreditosConst } from './creditos-const';
import { CreditosModel } from './creditos.model';
import { CreditosDialogDeleteComponent } from './creditos-dialog-delete.component';
import { CreditosDialogAttachmentComponent } from './creditos-dialog-attachment.component';
import { CreditosDialogCobroCuotasComponent } from './creditos-dialog-cobro-cuotas.component';
import { CreditosDialogDeudaACortoPlazoComponent } from './creditos-dialog-deuda-a-corto-plazo.component';
import { CreditosDialogConstitucionCreditoComponent } from './creditos-dialog-constitucion-credito.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-creditos-list',
    templateUrl: './creditos-list.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = CreditosConst.headerTable;

  public dataSource: CreditosModel[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  public download: boolean = false;
  public empty_guid = consts.EMPTY_GUID;

  constructor(
    private creditosService: CreditosService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  public getList() {
    this.creditosService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public constitucionCredito(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosDialogConstitucionCreditoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { creditos: creditosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public deudaACortoPlazo(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosDialogDeudaACortoPlazoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { creditos: creditosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public cobrarCuotas(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const creditosSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(CreditosDialogCobroCuotasComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { creditos: creditosSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public create() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/create']);
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(CreditosDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public uploadFileAttachment(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(CreditosDialogAttachmentComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public downloadFileAttachment(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.creditosService.downloadFileAttachment(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Fichero_Adjunto", consts.EXT_EXCEL));
    })
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
